export var StoreKey;
(function (StoreKey) {
    StoreKey["AUTH"] = "AUTH";
    StoreKey["CURRENT_PROJECT"] = "CURRENT_PROJECT";
    StoreKey["LOCALIZE"] = "LOCALIZE";
})(StoreKey = StoreKey || (StoreKey = {}));
;
;
